import React from 'react';
import classNames from 'classnames';

import { HEART_AVATAR_MARK, heartAvatarKeyOf, heartAvatarOption } from '../../util/heartAvatar';

import css from './HeartAvatar.module.css';

/**
 * Fills its (round) parent: chosen circle color + the official ear-heart.
 *
 * @param {Object} props
 * @param {Object} [props.user] user entity (reads publicData.avatarHeart)
 * @param {string} [props.heartKey] explicit key (wins over user)
 * @param {boolean} [props.listener] listing context: default to blue
 * @param {string} [props.className]
 * @param {boolean} [props.square] fill a rectangular slot (listing cards)
 * @returns {JSX.Element}
 */
export const HeartAvatarFace = props => {
  const { user, heartKey, listener, className, square = false } = props;
  const key = heartKey || heartAvatarKeyOf(user, { listener });
  const option = heartAvatarOption(key);
  return (
    <span
      className={classNames(css.face, { [css.faceRing]: option.ring }, className)}
      style={
        square
          ? { background: option.background, borderRadius: 'var(--borderRadiusMedium, 8px)' }
          : { background: option.background }
      }
      data-heart-avatar={option.key}
      data-square={square ? 'true' : undefined}
      aria-hidden="true"
    >
      <img className={css.mark} src={HEART_AVATAR_MARK} alt="" draggable="false" />
    </span>
  );
};

export default HeartAvatarFace;
